var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import { createContext, useCallback, useContext, useMemo, useState, } from "react";
var FiltersContext = createContext({});
var FiltersProvider = function (_a) {
    var children = _a.children;
    var _b = useState(1), currentPage = _b[0], setCurrentPage = _b[1];
    var _c = useState(true), fetchDataUsingFiltersEffect = _c[0], setFetchDataUsingFiltersEffect = _c[1];
    var _d = useState(""), selectedCompetition = _d[0], setSelectedCompetition = _d[1];
    var _e = useState({}), selectedCompetitionObject = _e[0], setSelectedCompetitionObject = _e[1];
    var _f = useState({}), selectedIndicator = _f[0], setSelectedIndicator = _f[1];
    var _g = useState({}), selectedEdition = _g[0], setSelectedEdition = _g[1];
    var _h = useState({}), selectedTeam = _h[0], setSelectedTeam = _h[1];
    var _j = useState({}), selectedPlayer = _j[0], setSelectedPlayer = _j[1];
    var _k = useState("descendent"), sort = _k[0], setSort = _k[1];
    var _l = useState(false), recomputAuxValues = _l[0], setRecomputAuxValues = _l[1];
    var _m = useState(false), showsChoosedFilters = _m[0], setShowsChoosedFilters = _m[1];
    var selectedEditionAux = useMemo(function () { return selectedEdition; }, [recomputAuxValues]);
    var selectedTeamAux = useMemo(function () { return selectedTeam; }, [recomputAuxValues]);
    var selectedPlayerAux = useMemo(function () { return selectedPlayer; }, [recomputAuxValues]);
    var handleSetFetchDataUsingFiltersEffect = useCallback(function (value) { return setFetchDataUsingFiltersEffect(value); }, []);
    var handleSetSelectedCompetitionObject = useCallback(function (value) { return setSelectedCompetitionObject(value); }, []);
    var handleSetRecomputAuxValues = useCallback(function () { return setRecomputAuxValues(function (prev) { return !prev; }); }, []);
    var handleSetShowsChoosedFilters = useCallback(function (visibility) { return setShowsChoosedFilters(visibility); }, []);
    var handleSetSort = useCallback(function () { return setSort(function (prev) { return prev === "descendent" ? "ascendent" : "descendent"; }); }, []);
    var handleResetFilters = useCallback(function (target) {
        var targetFunction = {
            edition: function () {
                setSelectedEdition({});
                setRecomputAuxValues(function (prev) { return !prev; });
                setFetchDataUsingFiltersEffect(true);
            },
            team: function () {
                setSelectedTeam({});
                setRecomputAuxValues(function (prev) { return !prev; });
                setFetchDataUsingFiltersEffect(true);
            },
            player: function () {
                setSelectedPlayer({});
                setRecomputAuxValues(function (prev) { return !prev; });
                setFetchDataUsingFiltersEffect(true);
            },
            keepPrevious: function () {
                setSelectedEdition(selectedEditionAux);
                setSelectedTeam(selectedTeamAux);
                setSelectedPlayer(selectedPlayerAux);
            },
            all: function () {
                setSelectedEdition({});
                setSelectedTeam({});
                setSelectedPlayer({});
                setRecomputAuxValues(function (prev) { return !prev; });
                setShowsChoosedFilters(false);
                setFetchDataUsingFiltersEffect(true);
            },
            keepEdition: function () {
                setSelectedEdition(selectedEditionAux);
                setSelectedTeam({});
                setSelectedPlayer({});
                setRecomputAuxValues(function (prev) { return !prev; });
                setShowsChoosedFilters(true);
                setFetchDataUsingFiltersEffect(true);
            }
        };
        targetFunction[target]();
    }, [selectedEditionAux, selectedTeamAux, selectedPlayerAux]);
    var handleSetCurrentPage = useCallback(function (value) { return setCurrentPage(value); }, []);
    var handleSetSelectedCompetition = useCallback(function (value) {
        setSelectedCompetition(value);
        setCurrentPage(1);
    }, []);
    var handleSetSelectedItem = useCallback(function (value, key) {
        setCurrentPage(1);
        switch (key) {
            case "indicator":
                setFetchDataUsingFiltersEffect(true);
                setSelectedIndicator(value);
                break;
            case "edition":
                setFetchDataUsingFiltersEffect(false);
                setSelectedEdition(value);
                setSelectedTeam({});
                break;
            case "team":
                setFetchDataUsingFiltersEffect(false);
                setSelectedTeam(value);
                setSelectedPlayer({});
                break;
            case "player":
                setFetchDataUsingFiltersEffect(false);
                setSelectedPlayer(value);
                break;
            default:
                break;
        }
    }, []);
    return (_jsx(FiltersContext.Provider, __assign({ value: {
            handleSetRecomputAuxValues: handleSetRecomputAuxValues,
            selectedCompetition: selectedCompetition,
            selectedEdition: selectedEdition,
            selectedIndicator: selectedIndicator,
            selectedPlayer: selectedPlayer,
            selectedTeam: selectedTeam,
            handleSetSelectedCompetition: handleSetSelectedCompetition,
            handleSetSelectedItem: handleSetSelectedItem,
            handleResetFilters: handleResetFilters,
            handleSetCurrentPage: handleSetCurrentPage,
            currentPage: currentPage,
            handleSetSort: handleSetSort,
            sort: sort,
            handleSetFetchDataUsingFiltersEffect: handleSetFetchDataUsingFiltersEffect,
            fetchDataUsingFiltersEffect: fetchDataUsingFiltersEffect,
            selectedEditionAux: selectedEditionAux,
            selectedTeamAux: selectedTeamAux,
            selectedPlayerAux: selectedPlayerAux,
            showsChoosedFilters: showsChoosedFilters,
            handleSetShowsChoosedFilters: handleSetShowsChoosedFilters,
            handleSetSelectedCompetitionObject: handleSetSelectedCompetitionObject,
            selectedCompetitionObject: selectedCompetitionObject
        } }, { children: children })));
};
var useFilters = function () {
    var filtersContext = useContext(FiltersContext);
    return filtersContext;
};
export { FiltersProvider, useFilters };
